/**
 * @see {@link https://github.com/OneSignal/OneSignal-Website-SDK/blob/master/src/utils/OneSignalStub.ts}
 */
export type OneSignalStubFuncionList =
  | 'init'
  | '_initHttp'
  | 'isPushNotificationsEnabled'
  | 'showHttpPrompt'
  | 'registerForPushNotifications'
  | 'setDefaultNotificationUrl'
  | 'setDefaultTitle'
  | 'syncHashedEmail'
  | 'getTags'
  | 'sendTag'
  | 'sendTags'
  | 'deleteTag'
  | 'deleteTags'
  | 'addListenerForNotificationOpened'
  | 'getIdsAvailable'
  | 'setSubscription'
  | 'showHttpPermissionRequest'
  | 'showNativePrompt'
  | 'showSlidedownPrompt'
  | 'getNotificationPermission'
  | 'getUserId'
  | 'getRegistrationId'
  | 'getSubscription'
  | 'sendSelfNotification'
  | 'setEmail'
  | 'logoutEmail'
  | 'setExternalUserId'
  | 'removeExternalUserId'
  | 'getExternalUserId'
  | 'provideUserConsent'
  | 'isOptedOut'
  | 'getEmailId';

export interface OneSignalStub {
  init: (options: OneSignalOptions) => Promise<void>;
  registerForPushNotifications: () => Promise<void>;
  getUserId: () => Promise<string>;
  getRegistrationId: () => Promise<any>;
  getNotificationPermission: () => Promise<any>;
  setSubscription: (unmute: boolean) => Promise<void>;
  isPushNotificationsEnabled: (
    cb?: (isEnabled: boolean) => void,
  ) => Promise<boolean>;
  isOptedOut: () => Promise<boolean>;
  isPushNotificationsSupported: () => Promise<boolean>;
  subscriptionChange: (fnc: (isSubscribed: boolean) => void) => Promise<void>;

  push: (fnc: Array<string | any>) => Promise<any>;
  on: (func: string, callback: (result: any) => void) => void;

  context: {
    serviceWorkerManager: {
      getActiveState: () => Promise<string>;
    };
  };
  sdkEnvironment: {
    getWindowEnv: () => Promise<string>;
  };
}

/**
 * initialize OneSignal.
 * @see {@link https://documentation.onesignal.com/docs/web-push-sdk#section--init-}
 */
export abstract class OneSignalOptions {
  appId: string;
  autoRegister?: boolean;
  allowLocalhostAsSecureOrigin?: boolean;
  [prop: string]: any;
}
